// extracted by mini-css-extract-plugin
export default {"social":"GetSocial_social__xcxNg"};